import { Fragment } from "react";

import styles from "./styles";

export const ScrollSnapping = <T,>({
  array,
  component,
}: {
  array: Array<T>;
  component: (element: T) => JSX.Element;
}) => {
  return (
    <styles.Container className="no-scrollbar">
      {array.map((el, index) => (
        <Fragment key={index}>{component(el)}</Fragment>
      ))}
    </styles.Container>
  );
};
